import { render, staticRenderFns } from "./scope.svg.vue?vue&type=template&id=c88ea2c6&"
import script from "./scope.svg.vue?vue&type=script&lang=js&"
export * from "./scope.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports